<template>
    <div class="navbar" ref="navbar" style="left: 95px; transition: left 0.5s;">
        <a v-for="item in items" :key="item.dev_id" :class="{active:device.dev_id === item.dev_id}" href="javascript:;" @click="changeDevice(item)">
            <span>{{item.name}}</span>
        </a>
        <ButtonGroup class="scrollBtn" v-if="(contentWidth+20) > boxWidth || curStep != 0">
            <Button type="info" icon="ios-arrow-back" @click="prevBtn"></Button>
            <Button type="info" icon="ios-arrow-forward" @click="nextBtn"></Button>
        </ButtonGroup>
    </div>
</template>
<script>
export default {
    props: {
        items: Array,
        device: Object
    },
    data() {
        return {
            boxWidth: 0, //盒子的宽  navbar
            contentWidth: 0, //内容的宽  所有a标签
            steps: 0, //滚动的次数  一次70px
            curStep: 0 //当前所在的步数
        };
    },
    mounted() {
        //绑定窗口尺寸变化事件
        window.addEventListener('resize', () => {
            try {
                this.boxWidth = this.$refs.navbar.clientWidth;
                this.steps = Math.trunc((this.contentWidth - this.boxWidth + 140) / 70);
                if (this.steps < 0) this.steps = 0;
                this.steps += this.curStep;
            } catch (error) {}
        });
    },
    updated() {
        try {
            this.boxWidth = this.$refs.navbar.clientWidth;
            this.contentWidth = this.items.length * 140;
            this.steps = Math.trunc((this.contentWidth - this.boxWidth + 140) / 70);
            if (this.steps < 0) this.steps = 0;
            this.steps += this.curStep;
        } catch (error) {}
    },
    methods: {
        // 变更当前设备
        changeDevice(dev) {
            this.$emit('on-change-device', dev);
        },
        //向前滚动
        prevBtn() {
            if (this.curStep == 0) return;
            this.curStep--;
            let currLeft = Number.parseInt(this.$refs.navbar.style.left);
            this.$refs.navbar.style.left = currLeft + 70 + 'px';
        },
        //向后滚动
        nextBtn() {
            if (this.curStep == this.steps) return;
            this.curStep++;
            let currLeft = Number.parseInt(this.$refs.navbar.style.left);
            this.$refs.navbar.style.left = currLeft - 70 + 'px';
        }
    }
};
</script>
<style lang="less">
.navbar {
    .scrollBtn {
        position: absolute;
        right: 0;
        top: 0;
        bottom: 5px;
        padding: 7px 10px 7px 20px;
        height: 45px;
        background-color: #2f3234;
        button {
            padding: 5px;
        }
    }
    // .scrollBtn::before {
    //     content: '';
    //     position: absolute;
    //     top: 0;
    //     bottom: 0;
    //     left: -20px;
    //     right: 79px;
    //     background: linear-gradient(to left, #2f3234, #666);
    //     opacity: 0.5;
    // }
}
</style>





// WEBPACK FOOTER //
// src/views/group/components/navbar.vue